
// https://coolors.co/a95b96-e3abed-601b2e-fffafa-000000
export const LIGHT_THEME = {
    direction: 'rtl',
    palette: {
        mode: 'light',
        background: {
            default: '#FFFAFA',
            dark: '#111111',
            overlay: '#DDDDDD',
        },
        status: {
            success: '#73e482',
            warning: '#e7eb70',
            error: '#d26757',
        },
        primary: {
            main: '#A95B96',
            //light: '#E3ABED',
            light: '#d4b0b5',
            dark: '#601b2e',
            darkTransparent: '#3b0d18DD',
            contrastText: '#FFF',
        },
        secondary: {
            main: '#feecb0',
            light: '#fff8e0',
            dark: '#fee07e',
            contrastText: '#000',
        },
    },
};
